export default [
	{
		path: "/pros/settings",
		policy: "providerAuth",
		component: "Settings/Settings",
		exact: true,
		mui: true,
	},
	{
		path: "/pros/settings/saved-replies",
		policy: "providerAuth",
		exact: true,
		component: "SavedReplies/SavedReplies",
		mui: true,
	},
	{
		path: "/pros/settings/payments",
		policy: "providerAuth",
		exact: true,
		component: "Payments/Payments",
		mui: true,
	},
	{
		path: "/pros/settings/notifications",
		policy: "providerAuth",
		exact: true,
		component: "Notifications/Notifications",
		exact: true,
		mui: true,
	},
	{
		path: "/pros/settings/badges",
		policy: "providerAuth",
		exact: true,
		component: "Badges/Badges",
		mui: true,
	},
	{
		path: "/pros/settings/account",
		policy: "providerAuth",
		exact: true,
		component: "Account/Account",
		mui: true,
	},
];
